import React from 'react';
import EntryList from './EntryList';
import EntriesFilters from './EntriesFilters';
import EntriesSummary from './EntriesSummary';
import EntriesFooter from './EntriesFooter';

const CashierPage = () => (
  <div>
    <EntriesSummary />
    <EntriesFilters />
    <EntryList />
    <EntriesFooter />
  </div>
);

export default CashierPage;



// WEBPACK FOOTER //
// ./src/components/entries/CashierPage.js